export const RESET_MAX_IDLE_TIME = 'privacyLock/RESET_MAX_IDLE_TIME';
export const SET_CHAT_MAX_IDLE_TIME = 'privacyLock/SET_CHAT_MAX_IDLE_TIME';

export const resetMaxIdleTime = () => ({ type: RESET_MAX_IDLE_TIME });
export const setChatMaxIdleTime = () => ({ type: SET_CHAT_MAX_IDLE_TIME });
